import Slider, { SliderProps } from 'components/slider';
import { inputVarMap } from 'components/input-with-slider';
import ClearInputButton from 'components/clear-input-button';
import { InputWithSliderProps } from 'components/input-with-slider';

import styles from './styles.module.scss';

type InputsWithRangeSliderProps = {
  value: [number?, number?];
  onChange: (value: [number?, number?]) => void;
  placeholders?: [string?, string?];
  withSlider?: boolean;
} & Pick<InputWithSliderProps, 'inputVariant'> &
  Pick<SliderProps, 'min' | 'max' | 'step'>;

const InputsWithRangeSlider: React.FC<InputsWithRangeSliderProps> = (props) => {
  const { value, min, max, onChange, inputVariant, placeholders, withSlider = true } = props;

  const InputComponent = inputVarMap[inputVariant].component;

  return (
    <div className={styles.container}>
      <div className={styles.inputs}>
        <InputComponent
          value={Number(value[0])}
          placeholder={placeholders?.[0]}
          onChange={(v) => {
            if (v !== '-0') {
              onChange([Number(v), value[1]]);
              return;
            }
          }}
          min={min}
        />
        <InputComponent
          value={Number(value[1])}
          placeholder={placeholders?.[1]}
          onChange={(v) => {
            if (v !== '-0') {
              onChange([value[0], Number(v)]);
              return;
            }
          }}
          max={max}
        />
      </div>

      {withSlider && (
        <Slider min={min} max={max} value={value} onChange={(v: [number, number]) => onChange(v)} />
      )}
      <ClearInputButton onClick={() => onChange([])} />
    </div>
  );
};

export const getPlaceholdersForInputsWithRangeSlider = (
  min: number | null | undefined,
  max: number | null | undefined,
  formatter: (num: number) => string,
): InputsWithRangeSliderProps['placeholders'] => {
  const isMinNumber = typeof min === 'number';
  const isMaxNumber = typeof max === 'number';

  if (!isMinNumber && !isMaxNumber) return undefined;

  return [isMinNumber ? formatter(min) : undefined, isMaxNumber ? formatter(max) : undefined];
};

export default InputsWithRangeSlider;
